import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from 'src/app/_core/_services/api.service';

@Injectable({
  providedIn: 'root'
})
export class StatisticsService {
  constructor(private api: ApiService) {}

  getDeviceStatistics() {
    return this.api.getAPI<any>('management/statistics/devices').pipe(
      map((res) => {
        console.log('device statistics', res.body.data);
        return res.body.data;
      })
    );
  }

  getOrderMovements(weeks?: any) {
    if (weeks) {
      return this.api.getAPI<any>(`projects/statistics/order-metrics/movement?weeks=${weeks}`).pipe(
        map((res) => {
          console.log('orders summary', res.body.data);
          return res.body;
        })
      );
    }

    return this.api.getAPI<any>('projects/statistics/order-metrics/movement').pipe(
      map((res) => {
        console.log('orders summary', res.body.data);
        return res.body;
      })
    );
  }

  getCurrentOrderTrends() {
    return this.api.getAPI<any>('projects/statistics/order-metrics/current-trend').pipe(
      map((res) => {
        console.log('orders trends', res.body);
        return res.body;
      })
    );
  }

  getOrderTrends(weeks?: any) {
    if (weeks) {
      return this.api.getAPI<any>(`projects/statistics/order-metrics/trends?weeks=${weeks}`).pipe(
        map((res) => {
          console.log('orders trends', res.body);
          return res.body;
        })
      );
    }
    return this.api.getAPI<any>('projects/statistics/order-metrics/trends').pipe(
      map((res) => {
        console.log('orders trends', res.body);
        return res.body;
      })
    );
  }

  getCombinedOrderMetrics(weeks?: any) {
    if (weeks) {
      return this.api
        .getAPI<any>(`projects/statistics/order-metrics/combined-trends?weeks=${weeks}`)
        .pipe(
          map((res) => {
            console.log('combined orders metrics', res.body);
            return res.body;
          })
        );
    }

    return this.api.getAPI<any>(`projects/statistics/order-metrics/combined-trends`).pipe(
      map((res) => {
        console.log('combined orders metrics', res.body);
        return res.body;
      })
    );
  }

  getOrderMetricsByCustomer() {
    return this.api
      .getAPI<any>('projects/statistics/order-metrics/calculate-historic-customers')
      .pipe(
        map((res) => {
          console.log('calculate historic from current', res.body);
          return res.body;
        })
      );
  }

  getOrderMetricsByProduct() {
    return this.api
      .getAPI<any>('projects/statistics/order-metrics/calculate-historic-products')
      .pipe(
        map((res) => {
          console.log('calculate historic from current by product', res.body);
          return res.body;
        })
      );
  }
}
